import type { DeviceWidth } from "./types";

export const DEVICE_WIDTHS = ["small", "medium", "large"] as const;

export const DEVICES_WIDTHS_DIMENSIONS: Record<DeviceWidth, [number, number]> = {
    small: [0, 800],
    medium: [800, 1200],
    large: [1200, Infinity],
};
